/**
 * u-metro.js — фильтр по линии метро и сортировка на странице
 * /novostroyki/moscow/u-metro/ («Новостройки у метро в Москве»).
 *
 * ⛔ СТРАНИЦА ПОЛНОСТЬЮ РАБОТАЕТ БЕЗ ЭТОГО ФАЙЛА. Все карточки отрисованы на сервере
 * и лежат в документе в порядке «ближе к метро». Скрипт только прячет лишние
 * (классом) и переставляет уже существующие узлы — он ничего не подгружает и ничего
 * не создаёт. Поэтому краулер, не выполняющий JS, видит весь список целиком, а
 * отключённый JS не превращает страницу в пустую.
 *
 * ⛔ БЕЗ inline-обработчиков (CSP strict-dynamic): только addEventListener + data-*.
 */
(() => {
    'use strict';

    const cards = document.querySelector('[data-um-cards]');
    if (!cards) return;

    const items = Array.prototype.slice.call(cards.querySelectorAll('[data-um-item]'));
    if (!items.length) return;

    const lineButtons = Array.prototype.slice.call(document.querySelectorAll('[data-um-line]'));
    const sortSelect = document.querySelector('[data-um-sort]');
    const status = document.querySelector('[data-um-status]');
    const empty = document.querySelector('[data-um-empty]');

    let activeLine = 'all';

    /** Число из data-атрибута. Пропуск/мусор → Infinity: неизвестное уходит в хвост. */
    const num = (el, name) => {
        const raw = parseInt(el.getAttribute('data-' + name) || '', 10);
        return Number.isFinite(raw) && raw > 0 ? raw : Infinity;
    };

    /**
     * Склонение «ЖК» не требуется (аббревиатура не склоняется), поэтому строка статуса
     * собирается без словаря форм — иначе пришлось бы держать вторую копию правил
     * pluralRu в браузере.
     */
    const renderStatus = (shown) => {
        if (!status) return;
        status.textContent = shown === items.length
            ? 'Показаны все ' + items.length + ' ЖК'
            : 'Показано ' + shown + ' ЖК из ' + items.length;
    };

    const applyFilter = () => {
        let shown = 0;
        items.forEach((item) => {
            const match = activeLine === 'all' || item.getAttribute('data-line') === activeLine;
            item.classList.toggle('um-card--hidden', !match);
            if (match) shown += 1;
        });
        if (empty) empty.hidden = shown !== 0;
        renderStatus(shown);
    };

    const comparators = {
        walk: (a, b) => num(a, 'walk') - num(b, 'walk'),
        price: (a, b) => num(a, 'price') - num(b, 'price'),
        // Дороже — сначала, но дома БЕЗ цены («цена по запросу») всё равно в хвост:
        // простой разворот сравнения вынес бы их наверх, потому что Infinity больше
        // любой цены. Отсюда явная ветка вместо `-(a - b)`.
        price_desc: (a, b) => {
            const pa = num(a, 'price');
            const pb = num(b, 'price');
            if (pa === Infinity || pb === Infinity) return pa - pb;
            return pb - pa;
        },
        deadline: (a, b) => num(a, 'deadline') - num(b, 'deadline'),
    };

    const applySort = (key) => {
        const cmp = comparators[key];
        if (!cmp) return;
        const sorted = items.slice().sort(cmp);
        // Один DocumentFragment вместо N перестановок в живом дереве: 91 карточка,
        // и поштучный appendChild давал бы столько же пересчётов раскладки.
        const frag = document.createDocumentFragment();
        sorted.forEach((item) => frag.appendChild(item));
        cards.appendChild(frag);
    };

    lineButtons.forEach((btn) => {
        btn.addEventListener('click', () => {
            activeLine = btn.getAttribute('data-um-line') || 'all';
            lineButtons.forEach((other) => {
                const on = other === btn;
                other.classList.toggle('um-line--on', on);
                other.setAttribute('aria-pressed', on ? 'true' : 'false');
            });
            applyFilter();
        });
    });

    if (sortSelect) {
        sortSelect.addEventListener('change', () => {
            applySort(sortSelect.value);
            // Порядок изменился, видимость — нет; статус пересобираем, чтобы он не
            // разъехался с выдачей при смене сортировки на активном фильтре.
            applyFilter();
        });
    }
})();
